var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyBag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.776,
    height: 79.97,
    viewBox: "0 0 62.776 79.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-bag",
    transform: "translate(-55.048 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10553",
    "data-name": "Group 10553",
    transform: "translate(55.048 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40104",
    "data-name": "Path 40104",
    d: "M110.842,41.17l-4.8-4.57a7.466,7.466,0,0,0-.54-11.6l5.366-9.087a27.431,27.431,0,0,0-9.849-6.385l1.111-4.22L97.455,2.786a23.193,23.193,0,0,0-22.038,0L70.738,5.3l1.111,4.22c-3.139,1.068-7.329,3.292-9.849,6.385L67.366,25a7.466,7.466,0,0,0-.54,11.6l-4.8,4.57a22.506,22.506,0,0,0,15.525,38.8H95.317a22.507,22.507,0,0,0,15.525-38.8Zm-11.014-27.1a18.676,18.676,0,0,1,5.059,2.763l-3.963,6.71h-3.59ZM71.792,33.809a2.792,2.792,0,0,1,0-5.584h29.287a2.792,2.792,0,0,1,0,5.584ZM96.1,42.653a13.681,13.681,0,1,1-9.663-4A13.576,13.576,0,0,1,96.1,42.653ZM77.637,6.912a18.52,18.52,0,0,1,17.6,0l1.429.769L92.489,23.539H80.382L76.208,7.68Zm-4.593,7.154,2.493,9.474h-3.59l-3.963-6.711a18.678,18.678,0,0,1,5.059-2.764Zm22.273,61.22H77.554A17.821,17.821,0,0,1,65.261,44.562l6.373-6.072c.053,0,2.732,0,2.732,0q-.463.405-.906.846a18.351,18.351,0,1,0,25.952,0q-.442-.442-.906-.846s2.679,0,2.732,0l6.373,6.072A17.821,17.821,0,0,1,95.317,75.285Z",
    transform: "translate(-55.048 -0.001)",
    fill: "#fb6d3d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40105",
    "data-name": "Path 40105",
    d: "M202.325,291.213l9.939-9.939-9.939-9.939-9.939,9.939Zm3.313-9.939-3.313,3.313-3.313-3.313,3.313-3.313Z",
    transform: "translate(-115.889 -228.958)",
    fill: "#fb6d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBag);
export default __webpack_public_path__ + "static/media/money-bag.fc38f3ce50e85f56d59b1c295f4e39cf.svg";
export { ForwardRef as ReactComponent };